import { useI18n } from "vue-i18n";

const defaultOptions: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
};

export const formatLocaleDate = (
  value?: string | number | Date,
  locale?: string,
  options: Intl.DateTimeFormatOptions = defaultOptions,
) => {
  if (!value) return "";

  // If locale is not provided, try to get it from vue-i18n
  let activeLocale = locale;
  if (!activeLocale) {
    try {
      const { locale: i18nLocale } = useI18n();
      activeLocale = i18nLocale.value;
    } catch {
      activeLocale = "tr-TR";
    }
  }

  // Ensure locale is in BCP 47 format if it's just 'tr' or 'en'
  if (activeLocale === "tr") activeLocale = "tr-TR";
  if (activeLocale === "en") activeLocale = "en-US";

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  try {
    return new Intl.DateTimeFormat(activeLocale, options).format(date);
  } catch (error) {
    console.error("Date format error:", error);
    return "";
  }
};
